import { runtimeConfig } from '../config/runtime-config';

const localeConfig = {
  ru: {
    flagCode: 'ru',
    nativeName: 'Русский',
    modalLabelKey: 'generalSettings.language_ru',
    settingsLabelKey: 'language_ru',
    headerLabelKey: 'header.language_ru',
    headerShortKey: 'header.short_ru',
  },
  uz: {
    flagCode: 'uz',
    nativeName: "O'zbekcha",
    modalLabelKey: 'generalSettings.language_uz',
    settingsLabelKey: 'language_uz',
    headerLabelKey: 'header.language_uz',
    headerShortKey: 'header.short_uz',
  },
  en: {
    flagCode: 'en',
    nativeName: 'English',
    modalLabelKey: 'generalSettings.language_en',
    settingsLabelKey: 'language_en',
    headerLabelKey: 'header.language_en',
    headerShortKey: 'header.short_en',
  },
  he: {
    flagCode: 'he',
    nativeName: 'עברית',
    modalLabelKey: 'generalSettings.language_he',
    settingsLabelKey: 'language_he',
    headerLabelKey: 'header.language_he',
    headerShortKey: 'header.short_he',
  },
} as const;

type SupportedLocale = keyof typeof localeConfig;

const FALLBACK_LOCALE: SupportedLocale = 'ru';

export const isSupportedLocale = (value: string | null | undefined): value is SupportedLocale =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(localeConfig, value);

const runtimeLocales = runtimeConfig.languages.filter(isSupportedLocale);

export const appLocales = (runtimeLocales.length > 0 ? runtimeLocales : [FALLBACK_LOCALE]) as [
  SupportedLocale,
  ...SupportedLocale[],
];

export type AppLocale = (typeof appLocales)[number];

export const defaultAppLocale: AppLocale =
  isSupportedLocale(runtimeConfig.defaultLanguage) && appLocales.includes(runtimeConfig.defaultLanguage)
    ? runtimeConfig.defaultLanguage
    : appLocales[0];

export const isAppLocale = (value: string | null | undefined): value is AppLocale =>
  typeof value === 'string' && (appLocales as readonly string[]).includes(value);

export const getLocaleConfig = (locale: AppLocale) => localeConfig[locale];

export const allLocaleCodes = Object.keys(localeConfig) as SupportedLocale[];
